const CASH = 'CASH';

const CASHLESS = 'CASHLESS';

export const ITEM_PRICE = 'ITEM_PRICE';
export const ITEM_ADDON_PRICE = 'ITEM_ADDON_PRICE';
export const DELIVERY_FEE = 'DELIVERY_FEE';
export const CASH_HANDLING_FEE = 'CASH_HANDLING_FEE';
export const OTHER_ITEM = 'OTHER_ITEM';
export const SERVICE_FEE = 'SERVICE_FEE';
export const PLATFORM_FEE = 'PLATFORM_FEE';
export const PLATFORM_PARTNER_FEE = 'PLATFORM_PARTNER_FEE';

export const STATUS_UNKNOWN = 'Unknown';
export const STATUS_FAIL = 'Fail';
export const STATUS_SUCCESS = 'Success';
export const STATUS_IN_PROGRESS = 'InProgress';
export const STATUS_PENDING = 'Pending';

export const PAYMENT_METHOD_TYPE = {
  CASH,
  CASHLESS,
};

export const COD_PAYMENT_STATUS = {
  STATUS_UNKNOWN,
  STATUS_FAIL,
  STATUS_SUCCESS,
  STATUS_IN_PROGRESS,
  STATUS_PENDING,
};

export const COD_PAYMENT_PENDING_STATUS = [STATUS_IN_PROGRESS, STATUS_PENDING];

export const PAYMENT_ITEM_TYPE_LOCALES = {
  [ITEM_PRICE]: 'paymentDetails.itemPrice',
  [ITEM_ADDON_PRICE]: 'paymentDetails.itemAddonPrice',
  [DELIVERY_FEE]: 'paymentDetails.deliveryFee',
  [CASH_HANDLING_FEE]: 'paymentDetails.cashHandlingFee',
  [OTHER_ITEM]: 'paymentDetails.otherItem',
  [SERVICE_FEE]: 'paymentDetails.serviceFee',
  [PLATFORM_FEE]: 'paymentDetails.platformFee',
  [PLATFORM_PARTNER_FEE]: 'paymentDetails.platformPartnerFee',
};

export const PAYMENT_ITEM_DESCRIPTION_LOCALES = {
  [DELIVERY_FEE]: 'paymentDetails.feeDescriptions.deliveryFee',
  [PLATFORM_PARTNER_FEE]: 'paymentDetails.feeDescriptions.platformPartnerFee',
};
